import { render, staticRenderFns } from "./productionDetail.vue?vue&type=template&id=0fd771bd&"
import script from "./productionDetail.vue?vue&type=script&lang=js&"
export * from "./productionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports